import { BiggestTurnOnCompatibilityOptionsType } from './types';

export const BIGGEST_TURN_ON_COMPATIBILITY_OPTIONS: BiggestTurnOnCompatibilityOptionsType =
  [
    { id: 'confidence', title: '😘Confidence' },
    { id: 'innocence', title: '🙄 Innocence' },
    { id: 'mystery', title: '💋Mystery' },
  ];
